export default "__VITE_ASSET__C6l9HsEa__"